import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';

class DashboardHistoryActions {
  constructor() {
    this.generateActions(...generateAsyncActions('pushHistory', 'popHistory', 'resetHistory'));
  }

  pushHistory(path) {
    return dispatch => {
      dispatch();
      return Promise.resolve(path).then(this.pushHistorySuccess);
    };
  }

  popHistory(path) {
    return dispatch => {
      dispatch();
      return Promise.resolve(path).then(this.popHistorySuccess);
    };
  }

  resetHistory() {
    return dispatch => {
      dispatch();
      return Promise.resolve().then(this.resetHistorySuccess);
    };
  }
}

export default alt.createActions(DashboardHistoryActions);
